import { NotesManager } from '@modules/talents/components/NotesManager';
import { Box, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';

const TalentNotes = () => {
    const { id } = useParams<{ id: string }>();

    if (!id) {
        return null;
    }

    return (
        <Paper sx={{ borderRadius: 5, flex: 1, height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <NotesManager talentId={id} variant="embedded" />
        </Paper>
    );
};

export default TalentNotes;
